import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-placement-team',
  templateUrl: './placement-team.component.html',
  styleUrls: ['./placement-team.component.scss']
})
export class PlacementTeamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
